export const voiceAgent = {
  header: {
    title: "Agente IA de Voz",
    subBefore: "Atiende llamadas de teléfono por ti con IA en tiempo real. Se aplica a",
    subEmphasis: "toda tu cuenta",
    active: "Activo",
    inactive: "Inactivo",
  },
  loading: "Cargando configuración…",
  errors: {
    load: "No se pudo cargar la configuración.",
    save: "No se pudo guardar. Inténtalo de nuevo.",
  },
  phone: {
    title: "Número de teléfono",
    desc: "El número al que llaman tus huéspedes. Se crea uno propio para tu cuenta.",
    checking: "Comprobando tu número…",
    pendingTitle: "Telefonía pendiente de activar",
    pendingText: "La creación de números aún no está habilitada en tu cuenta. Escríbenos y lo activamos.",
    activeCountry: "Activo · país {country}",
    provisioning: "Aprovisionando… (puede tardar unos minutos)",
    release: "Liberar",
    numberCountry: "País del número",
    searching: "Buscando…",
    seeAvailable: "Ver disponibles",
    perMonth: "{cost}/mes",
    getThis: "Obtener este número",
    getOne: "Obtener un número",
    confirmRelease: "¿Seguro que quieres liberar el número? Dejará de recibir llamadas.",
    errNoneInCountry: "No hay números disponibles en este país ahora mismo.",
    errTelnyxInactive: "La telefonía aún no está activa en tu cuenta.",
    errSearchFailed: "No se pudieron buscar números.",
    errTelnyxInactiveContact: "La telefonía aún no está activa en tu cuenta. Escríbenos y la habilitamos.",
    errNoNumbersNow: "No hay números disponibles ahora mismo.",
    errProvisionFailed: "No se pudo obtener el número.",
    errReleaseFailed: "No se pudo liberar el número.",
  },
  voiceLang: {
    title: "Voz e idioma",
    assistantVoice: "Voz del asistente",
    recommended: "(recomendada)",
    listenVoiceTitle: "Escuchar la voz {voice}",
    loading: "Cargando…",
    stop: "Parar",
    listen: "Escuchar",
    mainLanguage: "Idioma principal",
    extraLanguages: "Idiomas adicionales que puede hablar",
    useIdentityTitle: "Usar la identidad del agente de chat",
    useIdentityDesc: "Reutiliza el nombre, la personalidad y el tono que ya definiste en Configuración General.",
    voiceAssistantName: "Nombre del asistente de voz",
    namePlaceholder: "p. ej. Recepción de Málaga Centro Suites",
    greeting: "Saludo al descolgar",
    optional: "(opcional)",
    greetingPlaceholder: "Si lo dejas vacío, el asistente saluda automáticamente con su identidad.",
    errPlayback: "No se pudo reproducir la muestra.",
    errGenerate: "No se pudo generar la muestra de voz. Inténtalo de nuevo.",
  },
  languages: {
    es: "Español",
    en: "Inglés",
    fr: "Francés",
    pt: "Portugués",
    it: "Italiano",
    de: "Alemán",
    ar: "Árabe",
  },
  countries: {
    ES: "España",
    US: "Estados Unidos",
    GB: "Reino Unido",
    FR: "Francia",
    IT: "Italia",
    DE: "Alemania",
    PT: "Portugal",
    CO: "Colombia",
    MX: "México",
  },
  days: {
    mon: "Lun",
    tue: "Mar",
    wed: "Mié",
    thu: "Jue",
    fri: "Vie",
    sat: "Sáb",
    sun: "Dom",
  },
  listings: {
    title: "Alojamientos donde atiende",
    desc: "Elige para qué alojamientos responde el agente de voz en las llamadas.",
    all: "Todos los alojamientos",
    some: "Solo algunos",
    scopeNoteBefore: "Atiende a",
    scopeNoteStrong: "todos",
    scopeNoteAfter: "los alojamientos de la cuenta, incluidos los que añadas en el futuro.",
    searchPlaceholder: "Buscar alojamiento…",
    selectAll: "Seleccionar todos",
    clearAll: "Quitar todos",
    loadingListings: "Cargando alojamientos…",
    noListings: "Esta cuenta no tiene alojamientos.",
    noMatches: "Sin coincidencias.",
    noneWarn: "Si no seleccionas ninguno, el agente atenderá a todos.",
    allDesc: "También los que añadas en el futuro.",
    someDesc: "Solo los que marques aquí abajo.",
    selectedShort: "{n} de {total}",
  },
  capabilities: {
    title: "Qué puede hacer",
    knowledgeTitle: "De dónde saca la información",
    knowledgeDesc: "Elige qué consulta el agente cuando le preguntan por el alojamiento.",
    messagesTitle: "Tomar recados",
    messagesDesc: "Si no sabe algo, recoge el mensaje del huésped y te avisa a ti.",
    linksTitle: "Enviar enlaces tras la llamada",
    linksDesc: "Al colgar, manda por WhatsApp el enlace útil (check-in o reserva) si procede.",
    photosTitle: "Enviar fotos del equipamiento y comodidades",
    photosDesc: "Si quien llama pregunta por una comodidad que tiene fotos, el agente se las envía por WhatsApp al número desde el que llama.",
  },
  doc: {
    title: "Documento con información",
    desc: "Sube un PDF o un Word y el agente podrá responder con lo que ponga dentro.",
    dropTitle: "Subir un documento",
    dropHint: "PDF o Word (.docx), hasta 15 MB",
    uploading: "Subiendo el documento…",
    replace: "Cambiar",
    remove: "Quitar",
    chars: "{n} caracteres leídos",
    noText: "Este documento está escaneado: son imágenes y no se puede leer el texto. Sube uno con texto de verdad.",
    errType: "El archivo tiene que ser PDF o Word (.docx).",
    errSize: "El archivo no puede pasar de 15 MB.",
    errUpload: "No se pudo subir el documento. Inténtalo otra vez.",
    errRemove: "No se pudo quitar el documento. Inténtalo otra vez.",
    fuenteBase: "La base de conocimiento",
    fuenteBaseDesc: "La ficha de tus alojamientos: check-in, servicios, normas y FAQ.",
    fuenteDoc: "Un documento tuyo",
    fuenteDocDesc: "Solo el PDF o Word que subas aquí abajo, con sus instrucciones.",
    fuenteAmbas: "Las dos",
    fuenteAmbasDesc: "Primero el documento y, si la respuesta no está ahí, la ficha.",
    verTexto: "Ver lo que lee el agente",
    abrirOriginal: "Abrir el documento",
    previewTitle: "Lo que el agente lee de tu documento",
    previewSub: "Es el texto que se sacó del archivo. Si aquí falta algo, el agente tampoco lo sabe.",
    previewVacio: "No se pudo sacar texto de este archivo.",
    cerrar: "Cerrar",
    noUsado: "Está subido, pero ahora mismo el agente no lo usa: has elegido responder solo con la base de conocimiento.",
    faltaDoc: "Sube un documento para poder elegirlo como fuente.",
  },
  hours: {
    title: "Horario de atención",
    specific: "Horario concreto",
    closed: "Cerrado",
    afterHours: "Fuera de horario",
    afterVoicemail: "Tomar un mensaje de voz",
    afterMessage: "Reproducir un aviso y colgar",
    afterMessagePlaceholder: "Mensaje que se reproduce fuera de horario.",
  },
  recording: {
    title: "Grabación y cumplimiento",
    recordTitle: "Grabar las llamadas",
    recordDesc: "Guarda el audio de las llamadas para que puedas revisarlas.",
    noticeTitle: "Avisar de la grabación",
    noticeDesc: "El asistente informa al inicio de que la llamada puede grabarse (recomendado por RGPD).",
    transcribeTitle: "Transcribir las llamadas",
    transcribeDesc: "Genera un texto de cada conversación.",
    transcribeNeedsRecord: "La transcripción se saca del audio: con «Grabar las llamadas» apagado no se genera ninguna.",
  },
  advanced: {
    title: "Avanzado",
    maxDuration: "Duración máxima de llamada",
    minutesOption: "{n} minutos",
    aiEngine: "Motor de IA",
  },
  save: {
    saved: "Guardado ✓",
    save: "Guardar cambios",
    dirty: "Tienes cambios sin guardar",
    clean: "Todo guardado",
  },
  credits: {
    title: "Minutos de llamadas",
    desc: "Minutos incluidos cada mes según tus alojamientos. Cuando se agoten, recarga cuando quieras.",
    loading: "Cargando saldo…",
    minutesLeft: "min disponibles",
    recharge: "Recargar",
    includedThisMonth: "{used} de {total} min incluidos usados este mes",
    purchased: "{min} min comprados",
    empty: "Te has quedado sin minutos. Recarga para seguir recibiendo llamadas.",
    error: "No se pudo cargar el saldo.",
    modal: {
      title: "Recargar minutos",
      sub: "Elige un pack. El pago es único y los minutos se suman a tu saldo al instante.",
      pay: "Pagar con tarjeta",
      secure: "Pago seguro con Stripe.",
      close: "Cerrar",
      error: "No se pudo iniciar el pago. Inténtalo de nuevo.",
    },
  },
};
